import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage"

const firebaseConfig = {
    apiKey: "AIzaSyA5TBXFYDSZa_WbxMVeI8Lk1jT-_sXhkNc",
    authDomain: "kajbak-c17ad.firebaseapp.com",
    projectId: "kajbak-c17ad",
    storageBucket: "kajbak-c17ad.appspot.com",
    messagingSenderId: "354605987219",
    appId: "1:354605987219:web:3ecef24fa4041936172466"
  };

  firebase.initializeApp(firebaseConfig);

  export default firebase;